import { ASSET_PATHS } from '../../utils/assetPath';

import './ExcelFileIcon.css';

interface ExcelFileIconProps {
  /**
   * Additional CSS class name
   */
  className?: string;
  /**
   * Icon size in pixels
   */
  size?: number;
  /**
   * Accessible label for the icon
   */
  ariaLabel?: string;
}

function ExcelFileIcon({ className = '', size = 32, ariaLabel = 'Excel file' }: ExcelFileIconProps) {
  return (
    <img
      alt=''
      aria-label={ariaLabel}
      className={`excel-file-icon ${className}`}
      height={size}
      src={ASSET_PATHS.EXCEL_FILE_ICON}
      width={size}
    />
  );
}

export default ExcelFileIcon;
